// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: getcases.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "./google/protobuf/timestamp";
import {
  CancerType,
  cancerTypeFromJSON,
  cancerTypeToJSON,
  CaseStatus,
  caseStatusFromJSON,
  caseStatusToJSON,
} from "./schema";

export const protobufPackage = "login";

export interface GetCasesRequest {
  offset: number;
  pageSize: number;
}

export interface Case {
  id: string;
  providerId: string;
  cancerType: CancerType;
  submitTime: Date | undefined;
  intakeDataLink: string;
  aiJobStartTime?: Date | undefined;
  aiJobEndTime?: Date | undefined;
  claimedById?: string | undefined;
  claimTime?: Date | undefined;
  completeTime?: Date | undefined;
  status: CaseStatus;
  updatedAt: Date | undefined;
  surveyResponse?: number | undefined;
  surveyComment?: string | undefined;
}

export interface GetCasesResponse {
  cases: Case[];
}

function createBaseGetCasesRequest(): GetCasesRequest {
  return { offset: 0, pageSize: 0 };
}

export const GetCasesRequest: MessageFns<GetCasesRequest> = {
  encode(message: GetCasesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.offset !== 0) {
      writer.uint32(8).int64(message.offset);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int64(message.pageSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCasesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCasesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.offset = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pageSize = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCasesRequest {
    return {
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: GetCasesRequest): unknown {
    const obj: any = {};
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCasesRequest>, I>>(base?: I): GetCasesRequest {
    return GetCasesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCasesRequest>, I>>(object: I): GetCasesRequest {
    const message = createBaseGetCasesRequest();
    message.offset = object.offset ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseCase(): Case {
  return {
    id: "",
    providerId: "",
    cancerType: 0,
    submitTime: undefined,
    intakeDataLink: "",
    aiJobStartTime: undefined,
    aiJobEndTime: undefined,
    claimedById: undefined,
    claimTime: undefined,
    completeTime: undefined,
    status: 0,
    updatedAt: undefined,
    surveyResponse: undefined,
    surveyComment: undefined,
  };
}

export const Case: MessageFns<Case> = {
  encode(message: Case, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.providerId !== "") {
      writer.uint32(18).string(message.providerId);
    }
    if (message.cancerType !== 0) {
      writer.uint32(24).int32(message.cancerType);
    }
    if (message.submitTime !== undefined) {
      Timestamp.encode(toTimestamp(message.submitTime), writer.uint32(34).fork()).join();
    }
    if (message.intakeDataLink !== "") {
      writer.uint32(42).string(message.intakeDataLink);
    }
    if (message.aiJobStartTime !== undefined) {
      Timestamp.encode(toTimestamp(message.aiJobStartTime), writer.uint32(50).fork()).join();
    }
    if (message.aiJobEndTime !== undefined) {
      Timestamp.encode(toTimestamp(message.aiJobEndTime), writer.uint32(58).fork()).join();
    }
    if (message.claimedById !== undefined) {
      writer.uint32(66).string(message.claimedById);
    }
    if (message.claimTime !== undefined) {
      Timestamp.encode(toTimestamp(message.claimTime), writer.uint32(74).fork()).join();
    }
    if (message.completeTime !== undefined) {
      Timestamp.encode(toTimestamp(message.completeTime), writer.uint32(82).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(88).int32(message.status);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(98).fork()).join();
    }
    if (message.surveyResponse !== undefined) {
      writer.uint32(104).int32(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      writer.uint32(114).string(message.surveyComment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Case {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cancerType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.submitTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.intakeDataLink = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.aiJobStartTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.aiJobEndTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.claimedById = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.claimTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.completeTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.surveyResponse = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.surveyComment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Case {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      providerId: isSet(object.providerId) ? globalThis.String(object.providerId) : "",
      cancerType: isSet(object.cancerType) ? cancerTypeFromJSON(object.cancerType) : 0,
      submitTime: isSet(object.submitTime) ? fromJsonTimestamp(object.submitTime) : undefined,
      intakeDataLink: isSet(object.intakeDataLink) ? globalThis.String(object.intakeDataLink) : "",
      aiJobStartTime: isSet(object.aiJobStartTime) ? fromJsonTimestamp(object.aiJobStartTime) : undefined,
      aiJobEndTime: isSet(object.aiJobEndTime) ? fromJsonTimestamp(object.aiJobEndTime) : undefined,
      claimedById: isSet(object.claimedById) ? globalThis.String(object.claimedById) : undefined,
      claimTime: isSet(object.claimTime) ? fromJsonTimestamp(object.claimTime) : undefined,
      completeTime: isSet(object.completeTime) ? fromJsonTimestamp(object.completeTime) : undefined,
      status: isSet(object.status) ? caseStatusFromJSON(object.status) : 0,
      updatedAt: isSet(object.updatedAt) ? fromJsonTimestamp(object.updatedAt) : undefined,
      surveyResponse: isSet(object.surveyResponse) ? globalThis.Number(object.surveyResponse) : undefined,
      surveyComment: isSet(object.surveyComment) ? globalThis.String(object.surveyComment) : undefined,
    };
  },

  toJSON(message: Case): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.cancerType !== 0) {
      obj.cancerType = cancerTypeToJSON(message.cancerType);
    }
    if (message.submitTime !== undefined) {
      obj.submitTime = message.submitTime.toISOString();
    }
    if (message.intakeDataLink !== "") {
      obj.intakeDataLink = message.intakeDataLink;
    }
    if (message.aiJobStartTime !== undefined) {
      obj.aiJobStartTime = message.aiJobStartTime.toISOString();
    }
    if (message.aiJobEndTime !== undefined) {
      obj.aiJobEndTime = message.aiJobEndTime.toISOString();
    }
    if (message.claimedById !== undefined) {
      obj.claimedById = message.claimedById;
    }
    if (message.claimTime !== undefined) {
      obj.claimTime = message.claimTime.toISOString();
    }
    if (message.completeTime !== undefined) {
      obj.completeTime = message.completeTime.toISOString();
    }
    if (message.status !== 0) {
      obj.status = caseStatusToJSON(message.status);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.surveyResponse !== undefined) {
      obj.surveyResponse = Math.round(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      obj.surveyComment = message.surveyComment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Case>, I>>(base?: I): Case {
    return Case.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Case>, I>>(object: I): Case {
    const message = createBaseCase();
    message.id = object.id ?? "";
    message.providerId = object.providerId ?? "";
    message.cancerType = object.cancerType ?? 0;
    message.submitTime = object.submitTime ?? undefined;
    message.intakeDataLink = object.intakeDataLink ?? "";
    message.aiJobStartTime = object.aiJobStartTime ?? undefined;
    message.aiJobEndTime = object.aiJobEndTime ?? undefined;
    message.claimedById = object.claimedById ?? undefined;
    message.claimTime = object.claimTime ?? undefined;
    message.completeTime = object.completeTime ?? undefined;
    message.status = object.status ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.surveyResponse = object.surveyResponse ?? undefined;
    message.surveyComment = object.surveyComment ?? undefined;
    return message;
  },
};

function createBaseGetCasesResponse(): GetCasesResponse {
  return { cases: [] };
}

export const GetCasesResponse: MessageFns<GetCasesResponse> = {
  encode(message: GetCasesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cases) {
      Case.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCasesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCasesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cases.push(Case.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCasesResponse {
    return { cases: globalThis.Array.isArray(object?.cases) ? object.cases.map((e: any) => Case.fromJSON(e)) : [] };
  },

  toJSON(message: GetCasesResponse): unknown {
    const obj: any = {};
    if (message.cases?.length) {
      obj.cases = message.cases.map((e) => Case.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCasesResponse>, I>>(base?: I): GetCasesResponse {
    return GetCasesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCasesResponse>, I>>(object: I): GetCasesResponse {
    const message = createBaseGetCasesResponse();
    message.cases = object.cases?.map((e) => Case.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
